import { Link } from 'react-router-dom'

export function InviteRequiredPage() {
  return (
    <div className="page page-narrow">
      <header className="page-header">
        <h1>招待が必要です</h1>
        <p className="lede">
          このアカウントはまだ Maruya RAG に登録されていません。管理者からの招待を依頼してください。
        </p>
      </header>
      <section className="card">
        <Link to="/login" className="btn btn-primary">
          ログイン画面へ戻る
        </Link>
      </section>
    </div>
  )
}
